module.exports = __webpack_public_path__ + "img/00019.dcb12bc6.webp";